module.exports = __webpack_public_path__ + "static/media/hero3.3614046c.jpg";